import { Component, OnInit, Output, EventEmitter, TemplateRef } from '@angular/core';
import { Addresses } from 'src/app/_models/address';
import { ApiService } from 'src/app/_services/api.service';
import { BsModalService, BsModalRef, ModalDirective } from 'ngx-bootstrap/modal';
import { Parcel } from 'src/app/_models/parcel';
import { NotifyService } from 'src/app/_services/notify.service';

@Component({
  selector: 'app-ainAddress',
  templateUrl: './ainAddress.component.html',
  styleUrls: ['./ainAddress.component.scss']
})
export class AinAddressComponent implements OnInit {
  @Output() AddressList = new EventEmitter<Parcel>();
  modalRef: BsModalRef;
  fullList: Addresses;
  addressList: Parcel[];
  loading: boolean = false;
  selector: string = '.main-panel';


  fullAddress: address = {
    number: '',
    direction: '',
    street: '',
    type: '',
    unit: '',
    city: '',
    zipCode: ''
  };

  constructor(private apiService: ApiService, private modalService: BsModalService, private notify: NotifyService) { }

  addressLookUp(item: Parcel) {
    this.modalRef.hide();
    this.AddressList.emit(item);
  }

  openModal(template: TemplateRef<any>): void {
    this.apiService.getParcel(this.fullAddress.street.replace(/\D/g, '')).subscribe(data => {
      if (data.Parcel != null) {
        this.AddressList.emit(data.Parcel);
      }
    }, error => {
      this.loading = true;
      this.modalRef = this.modalService.show(template);
      this.apiService.getAddress(addressToString(this.fullAddress)).subscribe(data => {
        this.loading = false;
        this.fullList = data;
        this.addressList = data.Parcels.slice(0, 20);
        console.log(this.addressList);
      });
    });
  }

  onScroll() {

    let length = this.addressList.length;

    this.addressList = this.addressList.concat(this.fullList.Parcels.slice(length, length + 20))

    console.log('scrolled!!');
  }

  ngOnInit() {
  }

}

interface address {
  number: string;
  direction: string;
  street: string;
  type: string;
  unit: string;
  city: string;
  zipCode: string;
}

export function addressToString(address: any) {
  let returnAddress = '';
  for ( const key of Object.keys(address) ) {
    const value = address[key];
    if(value != '')
      returnAddress += value + ' '
  }
  return returnAddress;
}
